import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@sona/angular-util-environment';
import { firstValueFrom } from 'rxjs';

import { SonaAuthFacade } from './auth.facade';

/**
 * A facade for the accept-terms page
 */
@Injectable({
    providedIn: 'root'
})
export class SonaAuthAcceptTermsFacade {

    private readonly _environment = inject(ENVIRONMENT);
    private readonly _httpClient = inject(HttpClient);
    private readonly _authFacade = inject(SonaAuthFacade);

    /**
     * Confirms that the user accepted the terms
     *
     * @param termsAccepted - Whether the user accepted the terms
     */
    async acceptTerms(termsAccepted: boolean) {
        if (!termsAccepted) {
            throw new Error('The terms must be accepted');
        }

        await firstValueFrom(this._httpClient.post('/api/auth/accept-terms', {
            termsAcceptedVersion: this._environment.legal.terms.version
        }));
    }

    /**
     * Signs the user out
     */
    signOut() {
        return this._authFacade.signOut();
    }
}
